import { useLanguage } from "@/i18n/LanguageContext";

export default function About() {
  const { t } = useLanguage();

  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 lg:py-32 bg-gray-50"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          {/* Left - Image */}
          <div className="relative">
            <div className="aspect-[4/3] overflow-hidden border border-gray-200">
              <img
                src="https://images.unsplash.com/photo-1663181191222-a20536e7419c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHx3aGl0ZSUyMGRlbGl2ZXJ5JTIwdmFuJTIwcmVudGFsfGVufDB8fHx8MTc3NjI3NDcxOXww&ixlib=rb-4.1.0&q=85"
                alt="RentComing service"
                className="w-full h-full object-cover"
                data-testid="about-image"
              />
            </div>
            <div className="absolute -top-4 -right-4 w-20 h-20 bg-red-600 -z-10 hidden lg:block" />
          </div>

          {/* Right - Text */}
          <div className="space-y-8">
            <div className="inline-block">
              <span
                data-testid="about-tag"
                className="text-xs font-bold tracking-[0.2em] uppercase text-red-600 font-body"
              >
                {t.about.tag}
              </span>
              <div className="w-full h-0.5 bg-red-600 mt-1" />
            </div>

            <h2
              data-testid="about-title"
              className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-none text-gray-900 font-heading"
            >
              {t.about.title}
            </h2>

            <p
              data-testid="about-description"
              className="text-base sm:text-lg leading-relaxed text-gray-600 font-body"
            >
              {t.about.description}
            </p>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-6 pt-8 border-t border-gray-200">
              <div data-testid="about-stat-1">
                <div className="text-3xl lg:text-4xl font-black text-gray-900 font-heading">
                  500+
                </div>
                <div className="text-sm text-gray-500 font-body mt-1">
                  {t.about.stat1Label}
                </div>
              </div>
              <div data-testid="about-stat-3">
                <div className="text-3xl lg:text-4xl font-black text-gray-900 font-heading">
                  Antwerpen
                </div>
                <div className="text-sm text-gray-500 font-body mt-1">
                  {t.about.stat3Label}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
